


























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Blurb from 'frontend/components/containers/Blurb.vue';
import Modal from 'frontend/components/Modal.vue';
import { mapGetters } from 'vuex';
import { MobileGetter } from 'frontend/types';

interface SubpackInterestModalContent {
  title: string;
  description: string;
  buttonText: string;
}

@Component({
  components: {
    Blurb,
    Modal,
  },
  computed: {
    ...mapGetters('globals', ['isAuthenticated']),
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class CourseSubpackInterestModal extends Vue {
  private isMobile!: MobileGetter;

  private closeSubpackModal(): void {
    this.$emit('subpack-button-clicked');
  }
}
